import React from "react";
import lazyPage from "../../../../../common/helpers/lazyPage";
import LoadingFrame from "../../../LoadingFrame";
export default lazyPage(
    "src/front/components/Task/types/Chords3/chords3.tsx",
    () => import("./chords3"),
    <LoadingFrame />,
);
